var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2908)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5271 20.15C21.7271 20.15 21.1171 19.925 20.6971 19.475C20.2771 19.015 20.0671 18.36 20.0671 17.51V16.685H21.6271V17.63C21.6271 18.31 21.9121 18.65 22.4821 18.65C23.0521 18.65 23.3371 18.31 23.3371 17.63V15.275C23.3371 14.585 23.0521 14.24 22.4821 14.24C21.9121 14.24 21.6271 14.585 21.6271 15.275V15.365H20.0671L20.3671 9.5H24.7171V11H21.8371L21.7021 13.505H21.7321C22.0421 12.995 22.5171 12.74 23.1571 12.74C23.7571 12.74 24.2121 12.945 24.5221 13.355C24.8321 13.765 24.9871 14.36 24.9871 15.14V17.51C24.9871 18.36 24.7771 19.015 24.3571 19.475C23.9371 19.925 23.3271 20.15 22.5271 20.15Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2908",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2908",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.13c88c55d133bd723111c7e0aaa04d03.svg";
export { ForwardRef as ReactComponent };